import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getUserData } from "../utils/auth-helpers";
import { isActorInvitePath } from "../utils/account-context";
import {
  applyAccountTheme,
  DEFAULT_ACCOUNT_THEME,
  getAccountTheme,
  mergeUserThemePreferences,
  normalizeAccountTheme,
  savePersistedThemeMode,
} from "../utils/account-branding-theme";

export const useApplyThemeFromBranding = ({ accountId, branding, selectedMode }) => {
  const location = useLocation();

  useEffect(() => {
    if (isActorInvitePath(location.pathname)) {
      applyAccountTheme(DEFAULT_ACCOUNT_THEME);
      return;
    }

    const baseBranding = branding ? normalizeAccountTheme(branding) : getAccountTheme(accountId);
    const prefs = typeof window !== "undefined" ? getUserData()?.theme_preferences : null;
    const withUser = mergeUserThemePreferences(baseBranding, prefs);
    const modeToApply = selectedMode || withUser.mode;
    const nextTheme = normalizeAccountTheme({ ...withUser, mode: modeToApply });

    applyAccountTheme(nextTheme);
    if (accountId) {
      savePersistedThemeMode(accountId, nextTheme.mode);
    }
  }, [accountId, branding, selectedMode, location.pathname]);
};

export default useApplyThemeFromBranding;
